import { render, staticRenderFns } from "./customerInquires.vue?vue&type=template&id=9fb525b0&scoped=true&"
import script from "./customerInquires.vue?vue&type=script&lang=js&"
export * from "./customerInquires.vue?vue&type=script&lang=js&"
import style0 from "./customerInquires.vue?vue&type=style&index=0&id=9fb525b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb525b0",
  null
  
)

component.options.__file = "customerInquires.vue"
export default component.exports